import { SubmitHandler, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Flex,
  Form,
  FormButtons,
  Input,
  NewPasswordInputs,
  NormalizedException,
  useRsaContext,
} from "@songtradr-sso/shared/frontend";
import {
  A,
  Alert,
  Body,
  Button,
  ButtonLoadingIcon,
  Heading,
} from "@songtradr/design-language";
import {
  FormFields,
  emailPasswordSignUp,
  routes,
  schema,
  text,
} from "./EmailPasswordSignUp.Parts";
import { Agreements } from "./agreements/Agreements";

export const EmailPasswordSignUp = () => {
  const navigate = useNavigate();
  const { rsaEncrypt } = useRsaContext();

  const formMethods = useForm<FormFields>({
    mode: "onSubmit",
    resolver: zodResolver(schema),
    criteriaMode: "all",
  });

  const {
    formState: { errors, isSubmitting },
    setError,
  } = formMethods;

  const onSubmit: SubmitHandler<FormFields> = async (data) => {
    try {
      const rsaEncryptedRequest = await rsaEncrypt(JSON.stringify(data));
      await emailPasswordSignUp(rsaEncryptedRequest);
      sessionStorage.setItem("email", data.email);
      navigate(routes.confirmEmail);
    } catch (err) {
      setError("root", { message: new NormalizedException(err).message });
    }
  };

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Flex $justify="space-between">
        <Heading variant="section">{text.title}</Heading>
        <Body variant="small">
          <A as={Link} to={routes.signIn} $disabled={isSubmitting}>
            {text.buttons.signIn}
          </A>
        </Body>
      </Flex>
      <Input
        id={text.shared.inputs.firstName.id}
        label={text.shared.inputs.firstName.label}
      />
      <Input
        id={text.shared.inputs.lastName.id}
        label={text.shared.inputs.lastName.label}
      />
      <Input
        id={text.shared.inputs.email.id}
        label={text.shared.inputs.email.label}
      />
      <NewPasswordInputs />
      <Alert message={errors.root?.message} dismissible />
      <FormButtons>
        <Button $variant="important" type="submit" disabled={isSubmitting}>
          {isSubmitting ? <ButtonLoadingIcon /> : text.buttons.submit}
        </Button>
      </FormButtons>
      <Agreements disabled={isSubmitting} />
    </Form>
  );
};
